import {
  getQuickbooksAuthorizationCallbackURL,
  getQuickbooksAuthorizeURL,
  getQuickbooksRefreshURL,
  getQuickbooksSyncInvoiceURL
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";

const useQuickbooksApi = () => {
  const QuickBooksAuthorize = async () => {
    try {
      const response = await privateAxios.post(getQuickbooksAuthorizeURL);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const QuickBooksCallBack = async (bodyObj = {}) => {
    try {
      const response = await privateAxios.post(
        getQuickbooksAuthorizationCallbackURL,
        bodyObj
      );
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const QuickBooksRefresh = async () => {
    const response = await privateAxios.post(getQuickbooksRefreshURL);
    return response;
  };

  const QuickBooksSyncInvoice = async () => {
    const response = await privateAxios.post(getQuickbooksSyncInvoiceURL);
    return response;
  };

  return {
    QuickBooksAuthorize,
    QuickBooksCallBack,
    QuickBooksRefresh,
    QuickBooksSyncInvoice
  };
};

export default useQuickbooksApi;
